/**
 * Configurator form
 * ======================================
 * - jquery needed
 * - handled with ajax/configurator.php
 */

import $ from "jquery";

const $result = $("#result");
const $resultItems = $("#result-items");
const enableOffset = window.innerWidth > 991;
const extraOffset = enableOffset ? 60 : 30;

$("body").on("submit", "#configurator", function(e) {
	const $this = $(this);
	const $formSubmit = $this.find("button[type=submit]");

	const data = new FormData($this[0]);
	data.append("action", "configurator");

	// ajax js
	var xhr = new XMLHttpRequest();
	xhr.open("POST", ajaxUrl + "/index.php", true);

	$formSubmit.addClass("is-loading");

	xhr.send(data);

	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			// success
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.response);

				$resultItems.html(response.html);
				$result.removeAttr("hidden");
				$formSubmit.removeClass("is-loading");

				$("html,body").animate(
					{
						scrollTop: $result.offset().top - extraOffset
					},
					500
				);
			}
			// error
			else {
				$result.removeAttr("hidden");
				$formSubmit.removeClass("is-loading");
				console.log("ajaxForm error!", xhr);
			}
		}
	};

	e.preventDefault();
});

$("#configurator").on("change", ".configurator-control__control", function(e) {
	const $this = $(this);
	const $parent = $this.closest(".configurator__row");
	const $next = $parent.nextAll(".configurator__title");

	if ($next.length) {
		const position = $next.offset();

		$("html,body").animate(
			{
				scrollTop: position.top - extraOffset
			},
			500
		);
	}
});
